import { FiSearch, FiPlus } from "react-icons/fi";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { makeRequestAuth } from "../../_config/api";

function AllProperties() {
  const [properties, setProperties] = useState([]);
  console.log("propertiespropertiespropertiespropertiesproperties", properties);
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [expandedRows, setExpandedRows] = useState({});

  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [rejectReason, setRejectReason] = useState(""); 
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);


  const toggleRow = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const pageSize = 10;
  const maxVisiblePages = 5;

  const [filters, setFilters] = useState({
    keyword: "",
    year: "",
    type: "All",
    month: "All",
  });
  const [propertiesType, setPropertiesType] = useState("All");

  const fetchData = async () => {
    try {
      const resData = {
        keyWord: filters.keyword,
        fromDate: "",
        toDate: "",
        status: "pending",
        isDisable: false,
        sortOrder: "desc",
        sortBy: "createdAt",
        pageNo,
        size: pageSize,
        location: "",
        propertyType:
          propertiesType === "All" ? "" : propertiesType.toLowerCase(),
        listingCategory: "",
        price: "",
        area: "",
      };

      const response = await makeRequestAuth(
        "post",
        "/admin/getPropertyList",
        resData
      );
      setProperties(response.data.list || []);
      setTotalCount(response.data.total || 0);
    } catch (error) {
      console.error("Error fetching properties:", error);
      showErrorToast("Failed to fetch properties. Please try again later.");
      return;
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageNo, filters, propertiesType]);

  const onStatusSelect = (id, status) => {
    if (status === "rejected") {
      setSelectedPropertyId(id);
      setShowRejectModal(true);
    } else if (status === "approved") {
      setSelectedPropertyId(id);
      setShowApproveModal(true); // 👈 Approve Modal Khulega
    } else {
      handleStatusChange(id, status);
    }
  };


  const handleStatusChange = async (id, newStatus, reason = "") => {
    try {
      const response = await makeRequestAuth(
        "post",
        "/admin/updatePropertyStatus",
        {
          propertyId: id,
          status: newStatus,
          reason,
        }
      );

      if (response?.data?.error) {
        showErrorToast(response.data.error);
        return;
      }

      showSuccessToast("Property status updated!");
      fetchData();
    } catch (error) {
      showErrorToast("Failed to update status");
    }
  };


  const getPageNumbers = () => {
    const totalPages = Math.ceil(totalCount / pageSize);
    const start = Math.max(1, pageNo - Math.floor(maxVisiblePages / 2));
    const end = Math.min(start + maxVisiblePages - 1, totalPages);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const submitReject = async () => {
    if (!rejectReason.trim()) {
      showErrorToast("Please enter rejection reason");
      return;
    }

    await handleStatusChange(selectedPropertyId, "rejected", rejectReason);

    setShowRejectModal(false);
    setRejectReason("");
    setSelectedPropertyId(null);
  };

    const submitApprove = async () => {
    await handleStatusChange(selectedPropertyId, "approved");
    setShowApproveModal(false);
    setSelectedPropertyId(null);
  };



  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <>
      <div className="p-4 bg-white shadow rounded-2xl flex flex-col gap-6">
        <ToastContainer />

        {/* Header & Filters */}
        <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center gap-4 border-b border-gray-200 pb-3">
          <div>
            <h2 className="text-xl font-bold text-gray-800">
              Pending Properties
            </h2>
            <span className="text-sm text-gray-500">Total {totalCount}</span>
          </div>

          <div className="flex flex-wrap w-full lg:w-auto gap-4">
            {/* Search */}
            <div className="relative w-full sm:w-40">
              <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search..."
                value={filters.keyword}
                onChange={(e) => {
                  setFilters((f) => ({ ...f, keyword: e.target.value }));
                  setPageNo(1);
                }}
                className="pl-10 pr-4 py-2 border border-gray-300 bg-gray-100 rounded-xl w-full focus:outline-none focus:ring-blue-500"
              />
            </div>

            {/* Type Filter */}
            <div className="flex items-center gap-2 bg-gray-100 p-2 rounded-xl border border-gray-200 w-full sm:w-auto">
              <label className="text-sm text-gray-700 whitespace-nowrap">
                Type:
              </label>
              <select
                value={propertiesType}
                onChange={(e) => {
                  setPropertiesType(e.target.value);
                  setPageNo(1);
                }}
                className="px-4 bg-gray-100 rounded-lg focus:outline-none w-full sm:w-auto"
              >
                <option>All</option>
                <option>Apartment</option>
                <option>House</option>
                <option>Commercial</option>
                <option>Land</option>
                <option>Other</option>
              </select>
            </div>
          </div>
        </div>

        {/* Property List */}
        {properties.map((property) => (
          <div key={property._id} className="mb-4">
            <div className="flex flex-col md:flex-row justify-between gap-4 bg-gray-50 p-4 rounded-xl border border-gray-200">
              <div className="flex-shrink-0">
                <img
                  src={property?.uploadedPhotos?.[0] ?? ""}
                  alt="Property"
                  className="w-32 h-32 md:w-36 md:h-36 rounded-lg object-cover"
                />
              </div>

              <div className="flex flex-col flex-grow gap-1 min-w-0">
                <h3 className="text-lg font-semibold text-gray-800 truncate">
                  {property?.uploadBy?.name ?? "-"}
                </h3>
                <p className="text-sm text-gray-500">
                  Property: {property?.property ?? "-"}
                </p>
                <p className="text-sm text-gray-500">
                  Type: {property?.propertyType ?? "-"}
                </p>
                <p className="text-sm text-gray-500">
                  Furnishing: {property?.furnishing ?? "-"}
                </p>
                <p
                  className="text-sm text-gray-600 mt-1 line-clamp-3"
                  dangerouslySetInnerHTML={{
                    __html: property?.description ?? "-",
                  }}
                ></p>
              </div>

              <div className="flex flex-col justify-start md:items-end min-w-[120px] gap-3">
                {/* Status Select Box */}
                <select
                  value={property.status}
                  onChange={(e) => onStatusSelect(property._id, e.target.value)}
                  className={`mt-2 px-4 py-1 rounded-md border text-sm font-semibold focus:outline-none ${property.status === "pending"
                    ? "bg-yellow-50 border-yellow-500 text-yellow-600"
                    : property.status === "rejected"
                      ? "bg-red-50 border-red-500 text-red-600"
                      : "bg-green-50 border-green-500 text-green-600"
                    }`}
                >
                  <option value="pending">Pending</option>
                  <option value="rejected">Rejected</option>
                  <option value="approved">Approved</option>
                </select>

                {/* NAYA EDIT BUTTON IDHAR ADD KIYA HAI */}
                <Link
                  to={`/properties/edit/${property._id}`}
                  className="text-sm bg-blue-600 text-white px-3 py-1 rounded-lg hover:bg-blue-700 transition-colors text-center w-full"
                >
                  Edit Property
                </Link>

                {/* Details Toggle Button */}
                <button
                  onClick={() => toggleRow(property._id)}
                  className="text-sm text-blue-500 underline flex items-center gap-1 hover:text-blue-600"
                >
                  {expandedRows[property._id] ? "Hide Details" : "View Details"}
                  <span>{expandedRows[property._id] ? "▲" : "▼"}</span>
                </button>
              </div>
            </div>

            {expandedRows[property._id] && (
              <div className="bg-white border rounded-b-xl border-t-0 p-4 mt-[-1px] text-gray-700 text-sm">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                  <p>
                    <strong>Email:</strong> {property.uploadBy?.email}
                  </p>
                  <p>
                    <strong>Phone:</strong> {property.uploadBy?.phone}
                  </p>
                  <p>
                    <strong>City:</strong> {property.city}
                  </p>
                  <p>
                    <strong>Local Area:</strong> {property.localityArea}
                  </p>
                  <p>
                    <strong>Price:</strong> {property.price}
                  </p>
                  <p>
                    <strong>Area:</strong> {property.area}
                  </p>
                  <p>
                    <strong>Bathrooms:</strong> {property.bathrooms}
                  </p>
                  <p>
                    <strong>Listing Category:</strong>{" "}
                    {property.listingCategory}
                  </p>
                  <p>
                    <strong>Furnishing:</strong> {property.furnishing}
                  </p>
                  <p className="sm:col-span-2 lg:col-span-3">
                    <strong>Address:</strong> {property.propertyAddress}
                  </p>
                  <div className="sm:col-span-2 lg:col-span-3">
                    <strong>Description:</strong>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: property?.description ?? "-",
                      }}
                    ></p>
                  </div>
                  <p>
                    <strong>Created At:</strong>{" "}
                    {new Date(property.createdAt).toLocaleString()}
                  </p>
                </div>

                <div className="mt-4 flex flex-wrap gap-2">
                  {property.uploadedPhotos?.map((url, i) => (
                    <img
                      key={i}
                      src={url}
                      alt={`photo-${i}`}
                      className="w-20 h-20 rounded object-cover border"
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}

        <ToastContainer position="top-right" autoClose={3000} />

        {/* Pagination */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-2">
          <div className="text-sm font-bold text-gray-400">
            Showing data{" "}
            <span className="font-medium">{(pageNo - 1) * pageSize + 1}</span>{" "}
            to{" "}
            <span className="font-medium">
              {Math.min(pageNo * pageSize, totalCount)}
            </span>{" "}
            of <span className="font-medium">{totalCount}</span>
          </div>

          <div className="flex items-center space-x-1 text-sm font-bold text-gray-700">
            <button
              className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-400 disabled:opacity-50"
              onClick={() => setPageNo((prev) => Math.max(prev - 1, 1))}
              disabled={pageNo === 1}
            >
              &laquo;
            </button>

            {getPageNumbers().map((page) => (
              <button
                key={page}
                className={`px-3 py-1 rounded ${page === pageNo
                  ? "bg-orange-500 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-400"
                  }`}
                onClick={() => setPageNo(page)}
              >
                {page}
              </button>
            ))}

            <button
              className="px-2 py-1 rounded bg-gray-200 hover:bg-gray-400 disabled:opacity-50"
              onClick={() =>
                setPageNo((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={pageNo === totalPages}
            >
              &raquo;
            </button>
          </div>
          <div></div>
        </div>
        {showRejectModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-5 w-[90%] max-w-md">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">
                Reject Property
              </h3>

              <textarea
                rows={4}
                placeholder="Reason for rejection..."
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                className="w-full border rounded-lg p-2 focus:outline-none"
              />

              <div className="flex justify-end gap-3 mt-4">
                <button
                  onClick={() => {
                    setShowRejectModal(false);
                    setRejectReason("");
                  }}
                  className="px-4 py-1 rounded bg-gray-200"
                >
                  Cancel
                </button>

                <button
                  onClick={() => submitReject()}
                  className="px-4 py-1 rounded bg-red-600 text-white"
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        )}
                {/* Approve Confirmation Modal */}
        {showApproveModal && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-2xl space-y-4">
              <h3 className="text-lg font-bold text-gray-800">
                Confirm Approval
              </h3>

              <p className="text-sm text-gray-600">
                Are you sure you want to approve this property? Once approved, it will be listed live.
              </p>

              <div className="flex justify-end gap-3 pt-2">
                <button
                  onClick={() => {
                    setShowApproveModal(false);
                    setSelectedPropertyId(null);
                  }}
                  className="px-4 py-2 border rounded-xl text-sm font-semibold text-gray-600 hover:bg-gray-50 transition-all"
                >
                  Cancel
                </button>

                <button
                  onClick={submitApprove}
                  className="px-5 py-2 bg-green-600 hover:bg-green-700 text-white rounded-xl text-sm font-bold transition-all shadow-md"
                >
                  Confirm Approve
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}

export default AllProperties;
